const routesDebug = [
  {
    path: '/debug/flags',
    name: 'DebugFeatureFlags',
    component: () => import('@/views/debug/FeatureFlagsView.vue'),
    meta: {
      title: 'Feature flags',
      public: true
    }
  }
]

export default routesDebug
